import api from '@/api'

// 菜单 - 列表
export function getMenuList(params) {
    return api({
        url: '/api/admin/menu/list',
        method: 'get',
        params
    })
}

// 菜单 - 详情
export function getMenuInfo(params) {
    return api({
        url: '/api/admin/menu/info',
        method: 'get',
        params
    })
}

// 菜单 - 新增
export function addMenu(data) {
    return api({
        url: '/api/admin/menu/add',
        method: 'post',
        data
    })
}

// 菜单 - 编辑
export function editMenu(data) {
    return api({
        url: '/api/admin/menu/edit',
        method: 'post',
        data
    })
}

// 菜单 - 删除
export function delMenu(data) {
    return api({
        url: '/api/admin/menu/del',
        method: 'post',
        data
    })
}

// 菜单 - 树状
export function getMenuTree(params) {
    return api({
        url: '/api/admin/menu/tree',
        method: 'get',
        params
    })
}

// 菜单 - 排序
export function sortMenu(data) {
    return api({
        url: '/api/admin/menu/sort',
        method: 'post',
        data
    })
}

// 角色 - 列表
export function getRoleList(params) {
    return api({
        url: '/api/admin/role/list',
        method: 'get',
        params
    })
}

// 角色 - 详情
export function getRoleInfo(params) {
    return api({
        url: '/api/admin/role/info',
        method: 'get',
        params
    })
}

// 角色 - 新增
export function addRole(data) {
    return api({
        url: '/api/admin/role/add',
        method: 'post',
        data
    })
}

// 角色 - 编辑
export function editRole(data) {
    return api({
        url: '/api/admin/role/edit',
        method: 'post',
        data
    })
}

// 角色 - 删除
export function delRole(data) {
    return api({
        url: '/api/admin/role/del',
        method: 'post',
        data
    })
}

// 用户 - 列表
export function getUserList(params) {
    return api({
        url: '/api/admin/admin/list',
        method: 'get',
        params
    })
}

// 用户 - 详情
export function getUserInfo(params) {
    return api({
        url: '/api/admin/admin/info',
        method: 'get',
        params
    })
}

// 用户 - 新增
export function addUser(data) {
    return api({
        url: '/api/admin/admin/add',
        method: 'post',
        data
    })
}

// 用户 - 编辑
export function editUser(data) {
    return api({
        url: '/api/admin/admin/edit',
        method: 'post',
        data
    })
}

// 用户 - 删除
export function delUser(data) {
    return api({
        url: '/api/admin/admin/del',
        method: 'post',
        data
    })
}

// 用户 - 权限
export function getUserPermission(params) {
    return api({
        url: '/api/admin/admin/perms',
        method: 'get',
        params
    })
}

// 操作日志
export function getOperateLog(params) {
    return api({
        url: '/api/admin/oplog/list',
        method: 'get',
        params
    })
}

